import { createStore } from 'redux';
import { Provider } from 'react-redux';

import Dispatcher from '../dispatchers/dispatcher';
import React from 'react';
// import DebugHelper from '../helpers/debug_helper';

export default function customUseStore(Component, customReduxState) {
  class CustomUseStore extends React.Component {
    constructor(props) {
      super(props);

      Dispatcher.updateStore = function (callback) {
        this.reduxStore.dispatch({
          type: 'UPDATE_STORE',
          newState: callback(this.reduxStore.getState()),
        });
      }.bind(this);

      Dispatcher.getStore = function () {
        return this.reduxStore.getState();
      }.bind(this);

      Dispatcher.resetStore = function () {
        Dispatcher.updateStore(() => initialState);
      };

      const initialState = Object.assign(
        {
          additionalParams: [],
          adminFinancingRequest: null,
          approvedVendors: null,
          creditDocuments: [],
          stipStatusNotesArr: [],
          customer: null,
          customers: [],
          eligibility: null,
          eligibilitySection: null,
          energyDetails: [],
          equipmentList: null,
          errors: [],
          getState: () => {
            /* eslint-disable no-console */
            console.error(`Tried to call getState on Redux state.
You're probably passing down the state instead of the entire store.`);
            /* eslint-enable no-console */
          },
          modalDataEntryOnSubmit: () => console.log('waiting for this to be set'),
          failWhaleMessages: [],
          financingMethod: null,
          financingMethodCache: {},
          homeownerData: null,
          lastEvent: null,
          legalDocuments: null,
          productElements: [],
          financingRequest: null,
          locks: {},
          messages: [],
          proposal: null,
          sendForSignatureList: {
            signers: [],
            docs: [],
            submitted: false,
          },
          signature: null,
          systemArrays: null,
          advancedSystemArrays: null,
          utilities: null,
          view: {},
          zipCode: null,
          user: null,
          userFunctionalityAcls: [],
          userSettingValues: [],
          pageNumber: null,
          pollIntervalIds: null,
          pausePollingFlag: false,
          resetPassword: {
            passing: null,
            emailAddress: null,
          },
          displayCoApplicantSection: true,
          showDuplicateEmailModal: false,
          coapplicantIsDuplicate: false,
          openCoApp: false,
          verifiedSigners: null,
          viewableOwners: null,
          measures: [],
          proposalMeasures: [],
          userPreferredEmail: null,
          internalNotes: [],
          financingMethodUpdates: null,
          utilityAccounts: [],
          isGuestUser: true,
          defaultServiceAddressType: null,
          currentDecisioningDocSku: null,
          footnotes: new Map(),
        },
        customReduxState
      );

      // Warning: don't modify this! We're using the existing Dispatcher and actions instead.
      const reducer = (state = {}, action) => {
        if (action.type === 'UPDATE_STORE') {
          return { ...action.newState };
        } else if (action.type.startsWith('@@redux/INIT')) {
          return state;
        } else {
          /* eslint-disable no-console */
          console.warn("Don't use the Redux dispatcher. Use the Dispatcher module instead.");
          /* eslint-enable no-console */
          return state;
        }
      };

      this.reduxStore = createStore(reducer, initialState);

      // this.reduxStore.subscribe(() => {
      //   const reduxState = this.reduxStore.getState();
      //   DebugHelper.trackStore(reduxState);
      // });
    }

    render() {
      return (
        <Provider store={this.reduxStore}>
          <Component {...this.props} />
        </Provider>
      );
    }
  }

  return CustomUseStore;
}
